const state = {
  pagination: {
    page: 1,
    limit: 10,
    first: 0,
  },
  search: {
    query: '',
  }
};

const mutations = {
  updateHistoryPagination(state, {page, limit, first}) {
    state.pagination = {
      page,
      limit,
      first,
    };
  },
  updateHistorySearch(state, {query}) {
    state.search = {
      query,
    };
  },
};

const actions = {
  updateHistoryPagination({commit}, pagination) {
    commit('updateHistoryPagination', pagination);
  },
  updateHistorySearch({commit}, search) {
    commit('updateHistorySearch', search);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}; 